import {types} from './MeteostationsActions';

const defaultState = {
  filterStr: '',
  filterPath: 'root',
  filterMode: false,
  pending: true,
  sensors: [],
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case types.FETCH:
    case types.FETCH_PENDING:
    case types.FETCH_ERROR:
    case types.FETCH_SUCCESS:
    case types.FILTER:
    case types.FILTER_PATH:
    case types.FILTER_MODE:
    case types.SET_SENSORS:
      state = Object.assign({}, state, {...action.payload});
      break;
  }

  return state;
}
